import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import es from "../locales/es.json";

i18n.use(initReactI18next).init({
  compatibilityJSON: "v4",
  resources: {
    // "en-US": {
    //   translation: en,
    // },
    "es-419": {
      translation: es,
    },
  },
  fallbackLng: "es-419",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
